import { legacyPlanFilename, sanitizePlanFilename } from './sanitizePlanFilename';

/**
 * True when a SharePoint file is already among the saved plans. `savedNames`
 * holds the plan key suffixes (timestamp prefix stripped). A long name saved
 * before the extension was kept carries the old cut name, so match it too.
 */
export function isPlanSaved(fileName: string, savedNames: ReadonlySet<string>): boolean {
  return savedNames.has(sanitizePlanFilename(fileName)) || savedNames.has(legacyPlanFilename(fileName));
}
